import React from "react";

import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../../context/StateContext";
import { Booking } from "../../../../../models/booking";
import { CartonView } from "../../../../../models/carton";
import { GridQuantity } from "../../../../GridQuantity";
import { SubTitleProps } from "../../util";
import useStyles from "./styles";

interface Props {
  cartons: CartonView[];
  subtitle?: SubTitleProps;
  calledFromBooking: boolean;
  booking?: Booking;
  openedFromView?: boolean;
  calledFromShipment?: boolean;
}

const HeaderQuantities = (props: Props) => {
  const { cartons, subtitle, calledFromBooking, booking, openedFromView, calledFromShipment } =
    props;
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { isFMVersion } = useAppState();

  const getTotalItemsByValidates = () => {
    if (isFMVersion) return cartons.filter((carton) => carton.isReceivedByCfs).length;
    if (calledFromBooking) {
      return cartons.reduce((prev, curr) => prev + (curr.products?.length || 0), 0);
    }

    return cartons.length;
  };

  const scannedItems = (
    <GridQuantity
      small={!!openedFromView}
      title={(subtitle && subtitle.text) || translate("ssccQuantity")}
      value={(subtitle && subtitle?.quantity) || getTotalItemsByValidates() || 0}
      valueProps={{ "data-cy": "quantity" }}
    />
  );

  const totalSSCCs =
    (isFMVersion && calledFromBooking) || calledFromShipment ? (
      <GridQuantity
        small={!!openedFromView}
        title={translate("totalSSCC")}
        value={Number(booking?.bookedTotalQuantity || 0)}
        valueProps={{ "data-cy": "cbm" }}
      />
    ) : null;

  const items = [totalSSCCs, scannedItems];

  return (
    <div className={classes.rowCenter}>
      {items.map((item, index) => (
        <React.Fragment key={index}>{item}</React.Fragment>
      ))}
    </div>
  );
};

export default HeaderQuantities;
